import { useEffect, useState } from "react";

import Api from "lib/api/httpRequestHelper";

const BRAND_TO_MARCA = { karsten: 1, trussardi: 2, karsten_decor: 3 };

async function fetchPedidosDaVitrine(idVitrineVirtualB2b, idMarca) {
  try {
    const params = new URLSearchParams({ idVitrineVirtualB2b });
    if (idMarca !== "" && idMarca != null)
      params.set("idMarca", String(idMarca));
    const response = await Api.get(
      "virtual-showcase-b2b-list-pedidos",
      "showcaseB2B",
      `?${params.toString()}`,
      true,
    );
    return response?.Success && response?.Result?.Pedidos
      ? response.Result.Pedidos
      : [];
  } catch {
    return [];
  }
}

export default function useOrdersHistory({ vitrinesMeta, currentBrand }) {
  const [ordersModalOpen, setOrdersModalOpen] = useState(false);
  const [pedidosList, setPedidosList] = useState([]);
  const [loadingPedidos, setLoadingPedidos] = useState(false);

  useEffect(() => {
    if (!ordersModalOpen) return;

    const idsVitrine = [
      ...new Set(
        Object.values(vitrinesMeta || {})
          .map((v) => v?.idVitrineVirtualB2b)
          .filter((id) => id != null),
      ),
    ];
    if (idsVitrine.length === 0) {
      setPedidosList([]);
      return;
    }

    const idMarca = BRAND_TO_MARCA[currentBrand] ?? null;
    let cancelled = false;
    setLoadingPedidos(true);

    async function fetchPedidos() {
      try {
        const porVitrine = await Promise.all(
          idsVitrine.map((id) => fetchPedidosDaVitrine(id, idMarca)),
        );
        if (cancelled) return;
        const merged = porVitrine.flat().sort((a, b) => {
          const da = new Date(a?.DataHora ?? a?.dataHora ?? 0).getTime();
          const db = new Date(b?.DataHora ?? b?.dataHora ?? 0).getTime();
          return db - da;
        });
        setPedidosList(merged);
      } finally {
        if (!cancelled) setLoadingPedidos(false);
      }
    }
    fetchPedidos();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ordersModalOpen, vitrinesMeta, currentBrand]);

  const fetchPedidoDetalhe = async (
    idVitrineVirtualB2bPedido,
    idVitrineVirtualB2b,
  ) => {
    if (!idVitrineVirtualB2b) return null;
    try {
      const params = new URLSearchParams({
        idVitrineVirtualB2bPedido,
        idVitrineVirtualB2b,
      });
      const response = await Api.get(
        "virtual-showcase-b2b-pedido-detalhe",
        "showcaseB2B",
        `?${params.toString()}`,
        true,
      );
      if (response?.Success && response?.Result) return response.Result;
      return null;
    } catch {
      return null;
    }
  };

  return {
    ordersModalOpen,
    setOrdersModalOpen,
    pedidosList,
    loadingPedidos,
    fetchPedidoDetalhe,
  };
}
